// Module
var code = "<h2 id=\"phone-email-and-mail-contact\">Phone, Email, and Mail Contact</h2> <p>Find phone numbers, email addresses, or mailing addresses.</p> ";
// Exports
export default code;